import { h } from 'preact';
import { TableSkeleton } from '../TableSkeleton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'TableSkeleton',
  category: '⏳ Loading',
  description: 'Skeleton de tabela com rows e cols customizáveis',
  usedIn: ['Integrations', 'AgentesPage'],
  example: () => (
    <div style={{ maxHeight: 200, overflow: 'hidden' }}>
      <TableSkeleton rows={3} cols={4} />
    </div>
  ),
};
